import axios from "axios";
import firestore from "../firebase/firestore";

export const generateBatch = async (type, batch_id) => {
  const data = {
    type: type,
    batch_id: batch_id,
  };
  const token = localStorage.getItem("token");
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: process.env.VUE_APP_BANK_BATCHS,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    data: data,
  };
  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const scheduleBatch = async () => {
  let data = "";
  const token = localStorage.getItem("token");
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: process.env.VUE_APP_BANK_BATCHS,
    headers: {
      Authorization: "Bearer " + token,
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getBatchIdWithBillingId = async (billing_id) => {
  const docRef = await firestore
    .collectionGroup("batch_billets")
    .where("billing_id", "==", billing_id)
    .get();
  if (docRef.empty) {
    console.error(
      "Não foi possível encontrar o batch com o billing_id informado",
    );
    return null;
  } else {
    return docRef.docs.map((doc) => doc.data().batch_id);
  }
};

export const getBatchWithBarCode = async (bar_code) => {
  console.log("bar_code: ", bar_code);

  const docRef = await firestore
    .collectionGroup("batch_billets")
    .where("bar_code", "==", bar_code)
    .get();
  if (docRef.empty) {
    console.error(
      "Não foi possível encontrar o batch com o billing_id informado",
    );
    return null;
  } else {
    return docRef.docs.map((doc) => doc.data().batch_id);
  }
};
